import React from 'react'
import { Dialog } from 'primereact/dialog'

export const Modal = ({
  children,
  noDismissable,
  visible = false,
  closable = true,
  style = {},
  styleContainer,
  header,
  footer,
  contentStyle = {},
  draggable = false,
  onHide = () => {}
}) => {
  const onHideFunction = () => {
    if (closable) return onHide()
    else return () => {}
  }
  return (
    <Dialog
      contentStyle={{ ...contentStyle }}
      header={header}
      modal
      dismissableMask={!noDismissable}
      draggable={draggable}
      showHeader={!!header}
      visible={visible}
      onHide={onHideFunction}
      closable={closable}
      style={{ ...style }}
      footer={footer}
    >
      {children}
    </Dialog>
  )
}
